/**
 * @name TwoFactorService
 * @description Servicio para verificar y reenviar codigos de doble factor
 */

import axios from 'axios';
import { Environment } from '@config';

const getLanguage = () => {
  try {
    const storedLanguage = JSON.parse(localStorage.getItem('ls.ty-Language'))?.language;
    if (storedLanguage) {
      return storedLanguage;
    }
  } catch (error) {
    // Fall back a idioma del navegador.
  }

  const browserLanguage = navigator.language || navigator.userLanguage || 'es';
  return browserLanguage.split('-')[0];
};

const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'Accept-Language': getLanguage()
  };
};

const getBaseUrl = () => {
  return Environment.getCurrent().endpoints.admin;
};

const verify = (payload) => {
  return axios.post(`${getBaseUrl()}/TwoFactor/Verify`, payload, { headers: getHeaders() })
    .then(({ data }) => {
      return data;
    });
};

const resend = (challengeId) => {
  const payload = typeof challengeId === 'object' ? challengeId : { ChallengeId: challengeId };

  return axios.post(`${getBaseUrl()}/TwoFactor/Resend`, payload, { headers: getHeaders() })
    .then(({ data }) => {
      return data;
    });
};

const isChallengeResponse = (data = {}) => {
  return Boolean(data.RequiresTwoFactor || data.requiresTwoFactor || data.ChallengeId || data.challengeId);
};

const normalizeChallengeResponse = (data = {}) => {
  return {
    requiresTwoFactor: Boolean(data.RequiresTwoFactor ?? data.requiresTwoFactor ?? true),
    challengeId: data.ChallengeId || data.challengeId || '',
    maskedEmail: data.MaskedEmail || data.maskedEmail || '',
    expiresInSeconds: data.ExpiresInSeconds ?? data.expiresInSeconds ?? null,
    resendAvailableInSeconds: data.ResendAvailableInSeconds ?? data.resendAvailableInSeconds ?? null
  };
};

export const TwoFactorService = {
  verify,
  resend,
  isChallengeResponse,
  normalizeChallengeResponse
};
